module.exports = __webpack_public_path__ + "img/markerIconWhiteIB.9d5c6211.svg";